import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IRolResponse, 
  IRolRequest, 
  IPermisosRequest, 
  IPermisosResponse,
  IUpdatePermisoRequest,
  IUpdatePermisoResponse,
  IMenuSubmenuRequest,
  IMenuSubmenuResponse,
  IUpdateMenuSubmenuRequest,
  IUpdateModuleRequest
} from '../interfaces/rol.interface';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class BusquedaRolesService {
  private _url = environment.apiBaseUrl + 'api/rol/';
  private _urlNew = environment.apiNewBackBaseUrl; // API nuevo

  constructor(private _http: HttpClient) {}

  getRoles(): Observable<IRolResponse> {
    return this._http.get<IRolResponse>(this._url);
  }

  createRol(model: IRolRequest): Observable<IRolResponse> {
    return this._http.post<IRolResponse>(this._url, model, httpOption);
  }

  updateRol(model: IRolRequest): Observable<IRolResponse> {
    return this._http.put<IRolResponse>(this._url, model, httpOption);
  }

  deleteRol(id: number): Observable<IRolResponse> {
    return this._http.delete<IRolResponse>(`${this._url}${id}`);
  }

  // Método para obtener permisos del rol
  getPermisosRol(request: IPermisosRequest): Observable<IPermisosResponse> {
    const url = `${this._urlNew}Seguridad/Adm_Permisos_Form`;
    return this._http.post<IPermisosResponse>(url, request, httpOption);
  }

  // Método para actualizar permisos
  updatePermiso(request: IUpdatePermisoRequest): Observable<IUpdatePermisoResponse> {
    const url = `${this._urlNew}Seguridad/GetUpdtPermisos`;
    return this._http.post<IUpdatePermisoResponse>(url, request, httpOption);
  }

  // Método para obtener permisos de menús y submenús
  getPermisosMenusSubmenus(request: IMenuSubmenuRequest): Observable<IMenuSubmenuResponse> {
    const url = `${this._urlNew}Promociones/GetTemporalSeg3`;
    return this._http.post<IMenuSubmenuResponse>(url, request, httpOption);
  }

  // Método para actualizar permisos de menús/submenús
  updatePermisoMenuSubmenu(request: IUpdateMenuSubmenuRequest): Observable<IUpdatePermisoResponse> {
    const url = `${this._urlNew}Promociones/GetTemporalSeg3`;
    return this._http.post<IUpdatePermisoResponse>(url, request, httpOption);
  }

  // Método para actualizar estado de módulos (abuelos)
  updateModuleState(request: IUpdateModuleRequest): Observable<IUpdatePermisoResponse> {
    const url = `${this._urlNew}Promociones/TemporalSeg`;
    return this._http.post<IUpdatePermisoResponse>(url, request, httpOption);
  }
}
